let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("JoMnx"), load("hB5eh"), load("cQVlr")]).then(() => parcelRequire('6cfbi'));